import LTR from "@brand-icons/ploom/chevron-bold-forward/chevron-bold-forward-ltr.svg";
import RTL from "@brand-icons/ploom/chevron-bold-forward/chevron-bold-forward-rtl.svg";

import { iconFactory } from "../iconFactory";

export const ChevronBoldForwardIcon = iconFactory("ChevronBoldForwardIcon", LTR, RTL);
